import {useTranslation} from "react-i18next";
import Button from "../button/Button";
import AsyncTableGroupDropzone from "./AsyncTableGroupDropzone";

/**
 * Pasek akcji nad tabelą: strefa "Grupuj według" po lewej, akcje tabeli po prawej.
 * "Zwiń wszystkie" działa tylko w trybie grupowania.
 * Na wąskich ekranach przyciski zostają same z ikoną, a pasek się zawija.
 * @param {*} param0
 * @returns
 */
export default function AsyncTableActionBar({
    onSettingsClick,
    groupColumns,
    groupRules,
    onRemoveGroup,
    onConfigureGroup,
    groupDroppableId,
    groupLevels = 0,
    onCollapseAll,
}) {
    const {t} = useTranslation();

    const isGrouped = groupLevels > 0;

    return (
        <div className="async-table-action-bar">
            <div className="async-table-action-bar-group">
                <span className="async-table-action-bar-title">
                    {t("grouping")}
                </span>
                <AsyncTableGroupDropzone
                    className="async-table-action-bar-dropzone"
                    columns={groupColumns}
                    rules={groupRules}
                    hint={t("dragColumnHeaderHereToGroup")}
                    onRemove={onRemoveGroup}
                    onConfigure={onConfigureGroup}
                    droppableId={groupDroppableId}
                />
            </div>
            <div className="async-table-action-bar-actions">
                <Button
                    type="button"
                    buttonStyle="text"
                    icon={<i className="fa-solid fa-angles-up" />}
                    title={t("grid.collapseAll")}
                    disabled={!isGrouped}
                    onClick={onCollapseAll}>
                    <span className="async-table-action-bar-label">
                        {t("grid.collapseAll")}
                    </span>
                </Button>
                <span
                    className="async-table-action-bar-divider"
                    aria-hidden="true"
                />
                <Button
                    type="button"
                    buttonStyle="bordered"
                    icon={<i className="fa-solid fa-sliders" />}
                    title={t("tableSettings")}
                    onClick={onSettingsClick}>
                    <span className="async-table-action-bar-label">
                        {t("tableSettings")}
                    </span>
                </Button>
            </div>
        </div>
    );
}
